import React from 'react';
import { IModalWindow } from '@hooks/useModalWindow';
import { ICaixaItem } from '@model/CaixaItem';
import { EnumCaixaTipoLancamento } from '@model/CaixaTipoLancamento';
import { CaixaRegistrarModal } from './CaixaRegistrarModal';

export type CaixaRegistrarCreditoModalProps = {
    modal: IModalWindow
    onCaixaItemRegistrado: (caixaItem: ICaixaItem) => void
}

export function CaixaRegistrarCreditoModal ({ modal, onCaixaItemRegistrado }: CaixaRegistrarCreditoModalProps) {
    return (
        <CaixaRegistrarModal 
            modal={modal}
            caixaTipoLancamento={EnumCaixaTipoLancamento.Credito}
            onCaixaItemRegistrado={onCaixaItemRegistrado}
        />
    )
}